import jwtInterceptor from '/src/shared/jwtInterceptor'

const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

const state = () => ({
  partsStructure: null
});

const actions = {
  async suggestCarType(c, query)
  {
    let url = apiUrl + 'carType/Suggest?q='+query;
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async searchCarType(c, {query,id})
  {
    let url = apiUrl + 'carType/search?t=1'+(query?'&q='+query:'')+(id?'&id='+id:'');
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async searchCarBrand(c, query)
  {
    let url = apiUrl + 'carBrand/search'+(query?'?q='+query:'');
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getBrandModels(c, id)
  {
    let url = apiUrl + 'carBrand/getModels?id='+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getModelTypes(c, id)
  {
    let url = apiUrl + 'carModel/getTypes?id='+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getPartsStructure({commit,state})
  {
    if (state.partsStructure)
    {
      return state.partsStructure;
    }
    let url = apiUrl + 'carPart/getStructure';
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data.parts)
    {
      commit("saveCarParts", response.data.parts);
      return response.data.parts;
    }
  },
  async getCarPart(c,{carTypeId,partId})
  {
    if (state.partsStructure)
    {
      return state.partsStructure;
    }
    let url = apiUrl + 'carType/getPartInfo?car_type_id='+carTypeId+'&car_part_id='+partId;
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data
    }
  }

};


const mutations = {
  saveCarParts(state, status)
  {
    state.partsStructure = status;
  }
};

const getters = {
  getPartsStructure(state)
  {
    return state.partsStructure;
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations:mutations
}